module.exports = __webpack_public_path__ + "static/media/tw.a4b47fff.svg";